export default "__VITE_ASSET__c8fb178c__"